// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_5v7","cls2":"CreateSocialItemModal-cls2_yR3 CreateSocialItemModal-cls1_5v7"};